import React from 'react';
import * as Styles from './SiteBuilderSuccess.styles';
import { SiteBuilderSuccessProps } from './SiteBuilderSuccess.types';
import { SliderImagesSection } from './components/SliderImagesSection';
import { Button, IconEdit, IconLoading } from 'gatorcomponents';
import { sliderImagesContent } from './AgentFactorySlider';

const SiteBuilderSuccess = ({
  locales,
  isMobile,
  handleRequestBuilderSso,
  loading,
}) => {
  const { siteCreated } = locales;

  return (
    <Styles.Wrapper data-testid="agent-factory-success-step">
      <Styles.BackgroundDecoration aria-hidden>
        <Styles.EllipsesContainer>
          <Styles.Ellipse1 />
          <Styles.Ellipse2 />
          <Styles.Ellipse3 />
        </Styles.EllipsesContainer>
      </Styles.BackgroundDecoration>

      <Styles.InnerContainer>
        <Styles.Title>{siteCreated.title}</Styles.Title>
        <Styles.Description>{siteCreated.description}</Styles.Description>

        <Styles.WrapperButton>
          <Button
            label={loading ? <IconLoading /> : siteCreated.button}
            iconRight={!loading && <IconEdit color="highPure" size={isMobile ? 'sm' : 'md'} />}
            onClick={handleRequestBuilderSso}
            variant="primary"
            size="large"
            width={isMobile ? 'full' : 'fit-content'}
            version="v2"
          />
        </Styles.WrapperButton>
      </Styles.InnerContainer>

      <SliderImagesSection content={sliderImagesContent} />
    </Styles.Wrapper>
  );
};

SiteBuilderSuccess.propTypes = SiteBuilderSuccessProps;

export default SiteBuilderSuccess;
